<template>
  <div class="slider-banner relative">
    <swiper :options="bannerOption" class="swiper" v-if="bannerData">
      <swiper-slide v-for="item in bannerData" :key="item.image_url">
        <a :href="item.url" target="_blank" class="cursor-pointer img">
          <img :src="item.image_url" class="object-contain w-full h-auto" :alt="item.name">
        </a>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div class="swiper-button-next swiper-button-next-banner focus:outline-none cursor-pointer hidden md:block mt-0"></div>
    <div class="swiper-button-prev swiper-button-prev-banner focus:outline-none cursor-pointer hidden md:block mt-0"></div>
  </div>
</template>

<script>
export default {
  props: {
    bannerData: {
      type: Array
    }
  },
  data () {
    return {
      bannerOption: {
        preloadImages: true,
        updateOnImagesReady: true,
        autoplay: {
          delay: 5000
        },
        slidesPerView: 2,
        centeredSlides: true,
        watchOverflow: true,
        loop: true,
        effect: 'slide',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1440: {
            autoplay: {
              delay: 5000
            },
            slidesPerView: 1.5,
            loop: true
          },
          1024: {
            autoplay: {
              delay: 5000
            },
            slidesPerView: 1.4,
            loop: true
          },
          768: {
            autoplay: {
              delay: 5000
            },
            slidesPerView: 1.4,
            loop: true
          },
          576: {
            autoplay: {
              delay: 5000
            },
            slidesPerView: 1,
            loop: true
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .slider-banner {
    min-height: 10vh;
    @media (min-width: 768px) {
      min-height: 20vh;
    }
    .swiper-button-next-banner {
      background-image: url('~@/assets/btn/arrowRight.png');
      background-size: contain;
      background-size: 35px 35px;
      background-position: center;
      width: 6vw;
      height: 100%;
      transform: translateY(-50%);
    }
    .swiper-button-prev-banner {
      background-image: url('~@/assets/btn/arrowLeft.png');
      background-size: contain;
      background-size: 35px 35px;
      background-position: center;
      width: 6vw;
      height: 100%;
      transform: translateY(-50%);
    }
    .swiper-slide-prev {
      transition: .3s;
      filter: opacity(.3);
      -webkit-filter: opacity(.3);
      margin: 0;
    }
    .swiper-slide-next {
      transition: .3s;
      filter: opacity(.3);
      -webkit-filter: opacity(.3);
      margin: 0;
    }
    .swiper-pagination-bullet {
      width: 7px;
      height: 7px;
    }
    .swiper-pagination-bullet-active {
      opacity: 1;
      background: #e60012;
    }
  }
</style>
